import OtpRequired from '@/components/Auth/OtpRequired'

const OtpRequiredScreen = () => {
  return <OtpRequired />
}

export default OtpRequiredScreen
